<template>
<div class="platformmerchantadd"  >
     <div class="top"> 
         <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button> 
         <el-button type="primary" size="medium"   :disabled="loading" @click="addAbcagent()">保存</el-button>     
      </div>
     <div class="subject" :style="`height: ${maxH}px;`">
         <el-form ref="ruleForm" :model="ruleForm" label-width="140px" :rules="rules">
                <el-form-item label="平台商户编号" prop="merId">
                    <el-input v-model.trim="ruleForm.merId" placeholder="请输入平台商户编号" :maxlength="50"></el-input>
                </el-form-item>               
                 <el-form-item label="平台商户名称" prop="merName">
                    <el-input v-model.trim="ruleForm.merName" placeholder="请输入平台商户名称" :maxlength="50"></el-input>
                </el-form-item>               
                <el-form-item label="学校" prop="schoolId">
                    <el-autocomplete class="inline-input" v-model="ruleForm.schoolName"  :fetch-suggestions="querySearch" placeholder="请输入学校名称"  :trigger-on-focus="false"  @select="handleSelecttwo" ></el-autocomplete>
                  </el-form-item>
                 <el-form-item label="证书密码" prop="passwd" >
                    <el-input v-model.trim="ruleForm.passwd" placeholder="请输入证书密码" auto-complete="new-password" :maxlength="50" show-password></el-input>
                </el-form-item>
                 <el-form-item label="短信验证码" prop="smsCode">
                    <el-input v-model.trim="ruleForm.smsCode" placeholder="请输入验证码" :maxlength="15"></el-input>
                    <el-button type="primary" @click="queryVerificationCodes()">获取验证码</el-button>
                </el-form-item>
                <el-form-item label="证书">
                      <uploader pathPrefix="notice" :extList="allFileTypeList" v-model="fileJson" :multiple="false"></uploader>
                </el-form-item> 
            </el-form>
       
     </div>
</div> 
</template>
<script>
import {querySchoolListByName,addAbcagent} from "@/api/platformmerchant";
import Uploader from "@/components/Uploader/WebUploader";
import mixin from "@/mixins/windowResize";
export default {
  data() {
    return {
      ruleForm: {
        smsCode: "", //		验证码
        passwd: "", //	证书密码	string
        merId: "", //	商户号	string
        merName: "", //	项目代码	string
        schoolId: "",
        schoolName: "", 
      },
      rules: {
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        passwd: [{ required: true, message: "请输入证书密码", trigger: "blur" }],
        merId: [{ required: true, message: "请输入平台商户编号", trigger: "blur" }],
        merName: [{ required: true, message: "请输入平台商户名称", trigger: "blur" }],
        schoolId:[ { required: true, message: '请选择学校', trigger: 'change' }],
      },
      loading: false,
      allFileTypeList: ["pfx"],
      fileJson: [],
    };
  },
  mixins: [mixin],
  components: { Uploader},
  created() {
  },
  methods: {
    querySearch(queryString, cb) {
      querySchoolListByName(queryString).then(res => res.data).then(data => {
                            if(data.result) {
                              let results=[]
                              let mydata=data.data;
                              for(let i=0;i<mydata.length;i++){
                                results.push({
                                  value:mydata[i].name,
                                  id:mydata[i].id
                                })
                              }
                              cb(results);
                            
                           }
        })        
      },
       handleSelecttwo(item) {
            this.ruleForm.schoolId=item.id,
            this.ruleForm.schoolName=item.value
      },
    queryVerificationCodes() {
      queryVerificationCode("abcagent ")
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "验证码请求成功!"
            });
          }
        })
        .catch(function() {});
    },
    addAbcagent() {
      if (this.fileJson.length == 0) {
        this.$message({
          type: "warning",
          message: "请上传证书！"
        });
        return;
      } 
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.loading = true;
          let obj={
              cert:{
                  filename: this.fileJson[0].fileName,
                  fileurl: this.fileJson[0].fileUrl,
                  passwd:this.ruleForm.passwd,
              },
              merId:this.ruleForm.merId,
              merName:this.ruleForm.merName,//	平台商户名称	string	
              schoolId:this.ruleForm.schoolId,//	学校id	string	
              schoolName:this.ruleForm.schoolName,//	学校名称	string
          }
          addAbcagent(obj,this.ruleForm.smsCode)
            .then(res => res.data)
            .then(data => {
              if (data.result) {
                this.$message({
                  message: "新增成功！",
                  type: "success",
                  duration: 1000
                });
                this.$router.go(-1);
              } else {
                this.$message({
                  type: "error",
                  message: data.msg
                });
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.platformmerchantadd {
  padding:12px;
  .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
  .subject {
    overflow: auto;
    .el-form {
      padding-top: 20px;
      width: 810px;
      margin: 0 auto;
      .el-input,.el-select,.el-autocomplete{
        width: 80%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/platformmerchant/platformmerchantadd.vue